import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatEUR } from "@/lib/formatters";

const RELEASE_OPTIONS = [
  { value: "ritiro_proprio", label: "Ritiro del cliente con mezzi propri" },
  { value: "riconsegna_trasporto", label: "Riconsegna con trasporto" },
  { value: "smaltimento", label: "Smaltimento in discarica" },
  { value: "riconsegna_smaltimento", label: "Riconsegna con trasporto + Smaltimento in discarica" },
];

export function StorageSection({ form, setForm, isEditable, storageTotal, paidMonths }) {
  const s = (field, val) => setForm({ ...form, [field]: val });
  const releaseType = form.storage_release_type || "";

  return (
    <div className="card-surface p-5 space-y-4">
      <h2 className="text-sm font-semibold font-['Outfit'] text-zinc-500 uppercase tracking-wider">Deposito Magazzino</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="flex flex-col">
          <Label className="text-xs text-zinc-500 min-h-[2rem] flex items-end pb-1 leading-tight">Costo Movimentazione (€)</Label>
          <Input data-testid="storage-handling-cost" type="number" min="0" step="0.01" placeholder="0 €" value={form.storage_handling_cost} onChange={(e) => s("storage_handling_cost", parseFloat(e.target.value) || 0)} disabled={!isEditable} className="rounded-sm" />
          <span className="text-[10px] text-zinc-400 mt-1 italic leading-tight">Informativo: indicazione di costo per movimentazioni future. Non incluso nei totali.</span>
        </div>
        <div className="flex flex-col">
          <Label className="text-xs text-zinc-500 min-h-[2rem] flex items-end pb-1 leading-tight">Costo Mensile (€)</Label>
          <Input data-testid="storage-monthly-cost" type="number" min="0" step="0.01" placeholder="0 €" value={form.storage_monthly_cost} onChange={(e) => s("storage_monthly_cost", parseFloat(e.target.value) || 0)} disabled={!isEditable} className="rounded-sm" />
        </div>
        <div className="flex flex-col">
          <Label className="text-xs text-zinc-500 min-h-[2rem] flex items-end pb-1 leading-tight">Mesi Deposito</Label>
          <Input data-testid="storage-months" type="number" min="0" value={form.storage_months} onChange={(e) => s("storage_months", parseInt(e.target.value) || 0)} disabled={!isEditable} className="rounded-sm" />
        </div>
        <div className="flex flex-col">
          <Label className="text-xs text-zinc-500 min-h-[2rem] flex items-end pb-1 leading-tight">Mesi Omaggio</Label>
          <Input data-testid="storage-free-months" type="number" min="0" value={form.storage_free_months} onChange={(e) => s("storage_free_months", parseInt(e.target.value) || 0)} disabled={!isEditable} className="rounded-sm" />
        </div>
      </div>

      {/* Release type + price */}
      <div className="border-t border-zinc-200 pt-4 space-y-3">
        <Label className="text-xs text-zinc-500">Modalità Riconsegna</Label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {RELEASE_OPTIONS.map((opt) => (
            <label key={opt.value}
              className={`flex items-center gap-2.5 px-3 py-2.5 border rounded-sm cursor-pointer transition-colors text-sm ${
                releaseType === opt.value
                  ? "border-[#002FA7] bg-blue-50/50 text-[#002FA7] font-medium"
                  : "border-zinc-200 text-zinc-600 hover:border-zinc-300"
              } ${!isEditable ? "opacity-60 pointer-events-none" : ""}`}
              data-testid={`storage-release-${opt.value}`}
            >
              <input
                type="radio"
                name="storage_release_type"
                value={opt.value}
                checked={releaseType === opt.value}
                onChange={() => s("storage_release_type", opt.value)}
                disabled={!isEditable}
                className="accent-[#002FA7]"
              />
              {opt.label}
            </label>
          ))}
        </div>
        {releaseType && releaseType !== "ritiro_proprio" && (
          <div className="space-y-1 max-w-xs">
            <Label className="text-xs text-zinc-500">Prezzo Riconsegna (€)</Label>
            <Input data-testid="storage-release-price" type="number" min="0" step="0.01" placeholder="0 €"
              value={form.storage_release_price || 0}
              onChange={(e) => s("storage_release_price", parseFloat(e.target.value) || 0)}
              disabled={!isEditable} className="rounded-sm" />
          </div>
        )}
      </div>

      {storageTotal > 0 && (
        <div className="flex justify-between items-center pt-2 border-t border-zinc-200">
          <span className="text-sm text-zinc-500">Totale Deposito ({paidMonths} {paidMonths === 1 ? "mese" : "mesi"} a pagamento)</span>
          <span className="text-sm font-semibold">{formatEUR(storageTotal)}</span>
        </div>
      )}
    </div>
  );
}
